// src/componentes/Cuerpos/submoduloscomunes/ClienteModal/ClienteModal.js

import React, { useState, useEffect } from 'react';
import './ClienteModal.css';
import PuenteApi from '../../../../pageauth/PuenteApi';
import Cargando from '../../../../Cargando';
import AuthUser from '../../../../pageauth/AuthUser';

const ClienteModal = ({ isVisible, onClose, SetMensaje }) => {

    const { ObtenerDatosDeCuitArca, AgregarNuevoCliente } = PuenteApi()
    const { getModule, getModuleSector } = AuthUser()

    const { StartCargando, StopCargando } = Cargando()

    // 1. Estados para los campos del formulario
    const [tipoDocumento, setTipoDocumento] = useState('CUIT');
    const [cuit, setCuit] = useState('');
    const [razonSocial, setRazonSocial] = useState('');
    const [condicionIVA, setCondicionIVA] = useState('RESP. INSCRIPTO'); // Valor por defecto
    const [domicilio, setDomicilio] = useState('');
    const [provincia, setProvincia] = useState('');
    const [localidad, setLocalidad] = useState('');
    const [codPostal, setCodPostal] = useState('');
    const [telefono, setTelefono] = useState('');
    const [celular, setCelular] = useState('');
    const [laboral, setLaboral] = useState('');
    const [email, setEmail] = useState('');
    const [observaciones, setObservaciones] = useState('');

    // Checkboxes
    const [cuentaCorriente, setCuentaCorriente] = useState(false);
    const [exentoPercepciones, setExentoPercepciones] = useState(false);
    const [convenioMultilateral, setConvenioMultilateral] = useState(false);
    const [percepcionIVA, setPercepcionIVA] = useState(false);
    const [habilitarNotificaciones, setHabilitarNotificaciones] = useState(false);
    const [Checkcombustible, setCheckcombustible] = useState(false);
    const [Checkmini, setCheckmini] = useState(false);
    const [Checkplaya, setCheckplaya] = useState(false);

    // Créditos y Precios (solo visualización o entrada, no interactivos aquí)
    const [creditoMaximo, setCreditoMaximo] = useState('0,00');
    const [saldoRemitos, setSaldoRemitos] = useState('0,00');
    const [creditoDisponible, setCreditoDisponible] = useState('0,00');
    const [precioEspecialVencimiento, setPrecioEspecialVencimiento] = useState('05/11/2025');

    // Estado del buscador (simulado)
    const [listadoPreciosAsociada, setListadoPreciosAsociada] = useState('');

    // Efecto para enfocar el primer campo al abrir el modal
    useEffect(() => {
        if (isVisible) {
            // Un pequeño retraso asegura que el modal esté completamente renderizado
            setTimeout(() => {
                document.getElementById('cuitInput')?.focus();
            }, 100);
            // Reiniciar todos los campos al abrir el modal
            setTipoDocumento('CUIT');
            setCuit('');
            setRazonSocial('');
            setCondicionIVA('RESP. INSCRIPTO');
            setDomicilio('');
            setProvincia('');
            setLocalidad('');
            setCodPostal('');
            setTelefono('');
            setCelular('');
            setLaboral('');
            setEmail('');
            setCuentaCorriente(false);
            setExentoPercepciones(false);
            setConvenioMultilateral(false);
            setPercepcionIVA(false);
            setHabilitarNotificaciones(false);
            setCheckcombustible(false);
            setCheckmini(false);
            setCheckplaya(false);
            setCreditoMaximo('0.00');
            setSaldoRemitos('0.00');
            setCreditoDisponible('0.00');
            setObservaciones('');
        }
    }, [isVisible]);

    const handleGuardar = async (e) => {
        e.preventDefault();
        // let cuentaCorriente_local = false;
        // let creditoMaximo_local = '0.00';
        // let saldoRemitos_local = '0.00';
        // let creditoDisponible_local = '0.00';
        // let checkcombustible_local = false;
        // let checkmini_local = false;
        // let checkplaya_local = false;
        // if (getModule() == 'Playa' || getModule() == 'Mini' || getModule() == 'Shop') {

        // } else {
        //     cuentaCorriente_local = cuentaCorriente;
        //     creditoMaximo_local = creditoMaximo;
        //     saldoRemitos_local = saldoRemitos;
        //     creditoDisponible_local = creditoDisponible;
        //     checkcombustible_local = Checkcombustible;
        //     checkmini_local = Checkmini;
        //     checkplaya_local = Checkplaya;
        // }
        let cuentaCorriente_local = cuentaCorriente;
        let creditoMaximo_local = creditoMaximo;
        let saldoRemitos_local = saldoRemitos;
        let creditoDisponible_local = creditoDisponible;
        let checkcombustible_local = Checkcombustible;
        let checkmini_local = Checkmini;
        let checkplaya_local = Checkplaya;
        // Lógica para guardar el cliente
        // Aquí puedes recopilar todos los estados y enviarlos a tu API
        const clienteData = {
            tipoDocumento,
            cuit: cuit,
            razon_social: razonSocial,
            condicion_iva: condicionIVA,
            domicilio: domicilio,
            provincia: provincia,
            localidad: localidad,
            cp: codPostal,
            telefono: telefono,
            celular: celular,
            telefono_laboral: laboral,
            email: email,
            cuenta_corriente: cuentaCorriente_local,
            exento: exentoPercepciones,
            convenio: convenioMultilateral,
            iva: percepcionIVA,
            notificaciones: habilitarNotificaciones,
            observaciones: observaciones,
            listado_precios_asociada: listadoPreciosAsociada,
            credito_maximo: creditoMaximo_local,
            saldo_remitos: saldoRemitos_local,
            credito_disponible: creditoDisponible_local,
            precio_especial_vencimiento: precioEspecialVencimiento,
            combustible: checkcombustible_local,
            minimercado: checkmini_local,
            playa: checkplaya_local,
        };
        StartCargando("Guardando", "Guardando nuevo cliente", 3000);
        const resultado = await AgregarNuevoCliente(clienteData);
        if (resultado === true) {
            StopCargando();
            SetMensaje("OK", "Cliente guardado exitosamente", 3000);
            onClose();
        } else {
            StopCargando();
        }
    };

    const handleCancelar = () => {
        SetMensaje("Info", "Operación de cliente cancelada.", 2000);
        onClose(); // Cerrar el modal sin guardar
    };

    const activarCuentaCorriente = (checked) => {
        // if (getModule() == 'Playa' || getModule() == 'Mini' || getModule() == 'Shop') {
        //     return;
        // }
        setCuentaCorriente(checked);
        if (checked) {
            let elemento = document.getElementById('creditomaximo');
            elemento.disabled = false;
            elemento = document.getElementById('saldoremito');
            elemento.disabled = false;
            elemento = document.getElementById('creditodisponible');
            elemento.disabled = false;
            elemento = document.getElementById('checkcombustible');
            elemento.disabled = false;
            elemento = document.getElementById('checkmini');
            elemento.disabled = false;
            elemento = document.getElementById('checkplaya');
            elemento.disabled = false;
        } else {
            setCreditoMaximo('0,00');
            setSaldoRemitos('0,00');
            setCreditoDisponible('0,00');
            setCheckcombustible(false);
            setCheckmini(false);
            setCheckplaya(false);
            let elemento = document.getElementById('creditomaximo');
            elemento.disabled = true;
            elemento = document.getElementById('saldoremito');
            elemento.disabled = true;
            elemento = document.getElementById('creditodisponible');
            elemento.disabled = true;
            elemento = document.getElementById('checkcombustible');
            elemento.disabled = true;
            elemento = document.getElementById('checkmini');
            elemento.disabled = true;
            elemento = document.getElementById('checkplaya');
            elemento.disabled = true;
        }
    };

    const buscar_datos_arca = async (e) => {
        e.preventDefault();
        if (cuit.trim() === '') {
            SetMensaje("Error", "Por favor, ingrese un CUIT válido.", 3000);
            return;
        }
        if (cuit.length !== 11) {
            SetMensaje("Error", "Por favor, ingrese un CUIT válido.", 3000);
            return;
        }
        StartCargando("Cargando", "Búsqueda en ARCA", 3000);
        // Lógica para buscar datos en ARCA usando el CUIT
        const resultado = await ObtenerDatosDeCuitArca(cuit);
        if (resultado.success === true) {
            setRazonSocial(resultado.dato.personaReturn.persona.razonSocial || '');
            setDomicilio(resultado.dato.personaReturn.persona.domicilio[0].direccion || '');
            setProvincia(resultado.dato.personaReturn.persona.domicilio[0].descripcionProvincia || '');
            setLocalidad(resultado.dato.personaReturn.persona.domicilio[0].localidad || '');
            setCodPostal(resultado.dato.personaReturn.persona.domicilio[0].codigoPostal || '');
            setCondicionIVA(resultado.dato.personaReturn.persona.condicionIva || 'RESP. INSCRIPTO');
            StopCargando();
            SetMensaje("OK", "Datos obtenidos de ARCA", 300);
        }

    }

    // Si el modal no es visible, no renderizamos nada
    if (!isVisible) return null;

    return (
        <div className="modal-overlay-cliente">
            <div className="modal-content-cliente">
                <form onSubmit={handleGuardar}>
                    {/* Sección Superior: CUIT, Razón Social, IVA */}
                    <div className="cliente-modal-section top-section">
                        <div className="cliente-modal-column left-column">
                            <div className="form-group">
                                <label>Tipo de Documento</label>
                                <select value={tipoDocumento} onChange={(e) => setTipoDocumento(e.target.value)}>
                                    <option>CUIT</option>
                                </select>
                            </div>
                            <div className="form-group">
                                <label>CUIT</label>
                                <div className="input-with-button">
                                    <input
                                        type="text"
                                        id="cuitInput"
                                        value={cuit}
                                        onChange={(e) => setCuit(e.target.value)}
                                    />
                                    <button className="btn-search" onClick={buscar_datos_arca}>
                                        <span className="icon-search">🔍</span>
                                    </button>
                                </div>
                            </div>
                            {/* <div className="form-group">
                                <label>Lista de Precios Asociada</label>
                                <div className="input-with-button">
                                    <input 
                                        type="text" 
                                        value={listadoPreciosAsociada} 
                                        onChange={(e) => setListadoPreciosAsociada(e.target.value)} 
                                    />
                                    <button className="btn-search">
                                        <span className="icon-search">🔍</span>
                                    </button>
                                </div>
                            </div> */}
                            <div className="form-group">
                                <label>Razon Social</label>
                                <input type="text" value={razonSocial} onChange={(e) => setRazonSocial(e.target.value)} />
                            </div>
                            <div className form-group>
                                <div className="form-row">
                                    {/* <div className="form-group half-width">
                                        <label>Codigo</label>
                                        <input type="text" value="7639" readOnly />
                                    </div> */}
                                    <div className="form-group half-width">
                                        <label>Condicion IVA</label>
                                        <select value={condicionIVA} onChange={(e) => setCondicionIVA(e.target.value)}>
                                            <option>RESP. INSCRIPTO</option>
                                            <option>CONSUMIDOR FINAL</option>
                                            <option>MONOTRIBUTISTA</option>
                                            <option>EXENTO</option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                            <div className="checkbox-row">
                                <label><input type="checkbox" checked={exentoPercepciones} onChange={(e) => setExentoPercepciones(e.target.checked)} /> Exento de percepciones</label>
                                <label><input type="checkbox" checked={convenioMultilateral} onChange={(e) => setConvenioMultilateral(e.target.checked)} /> Convenio Multilateral</label>
                                <label><input type="checkbox" checked={percepcionIVA} onChange={(e) => setPercepcionIVA(e.target.checked)} /> Percepcion IVA</label>
                                {/* Puedes añadir "Alicuotas Percepcion" como un input deshabilitado si aplica */}
                                <div className="text-label-inline"></div>
                            </div>
                        </div>

                        <div className="cliente-modal-column right-column">
                            <label className="checkbox-right"><input type="checkbox" checked={cuentaCorriente} onChange={(e) => activarCuentaCorriente(e.target.checked)} /> Cuenta Corriente</label>

                            <div className="form-group">
                                <label>Credito Maximo</label>
                                <input id="creditomaximo" type="text" value={creditoMaximo} onChange={(e) => setCreditoMaximo(e.target.value)} disabled />
                            </div>
                            <div className="form-group">
                                <label>Saldo + Remitos</label>
                                <input id="saldoremito" type="text" value={saldoRemitos} onChange={(e) => setSaldoRemitos(e.target.value)} disabled />
                            </div>
                            <div className="form-group">
                                <label>Credito Disponible</label>
                                <input id="creditodisponible" type="text" value={creditoDisponible} onChange={(e) => setCreditoDisponible(e.target.value)} disabled />
                            </div>

                            <div className="checkbox-group-horizontal">
                                <label><input id="checkcombustible" type="checkbox" checked={Checkcombustible} onChange={(e) => setCheckcombustible(e.target.checked)} disabled /> Combustibles</label>
                                <label><input id="checkmini" type="checkbox" checked={Checkmini} onChange={(e) => setCheckmini(e.target.checked)} disabled /> Minimercado</label>
                                <label><input id="checkplaya" type="checkbox" checked={Checkplaya} onChange={(e) => setCheckplaya(e.target.checked)} disabled /> Varios Playa</label>
                            </div>
                            {/* <div className="form-group">
                                <label>Precio Especial Vencimiento</label>
                                <input type="text" value={precioEspecialVencimiento} onChange={(e) => setPrecioEspecialVencimiento(e.target.value)} />
                            </div>
                            <div className="button-group-right">
                                <button type="button" className="btn-action">Agregar</button>
                                <button type="button" className="btn-action">Modificar</button>
                                <button type="button" className="btn-action">Quitar</button>
                            </div>
                            <textarea className="large-textarea-right" rows="4" placeholder=""></textarea> */}
                        </div>
                    </div>

                    {/* Sección Central: Domicilio y Contacto */}
                    <div className="cliente-modal-section middle-section">
                        <div className="form-group full-width">
                            <label>Domicilio</label>
                            <input type="text" value={domicilio} onChange={(e) => setDomicilio(e.target.value)} />
                        </div>
                        <div className="form-row">
                            <div className="form-group large-width">
                                <label>Provincia</label>
                                <div className="input-with-button">
                                    <input type="text" value={provincia} onChange={(e) => setProvincia(e.target.value)} />
                                </div>
                            </div>
                            <div className="form-group large-width">
                                <label>Localidad</label>
                                <div className="input-with-button">
                                    <input type="text" value={localidad} onChange={(e) => setLocalidad(e.target.value)} />
                                </div>
                            </div>
                            <div className="form-group small-width">
                                <label>Cod. Postal</label>
                                <input type="text" value={codPostal} onChange={(e) => setCodPostal(e.target.value)} />
                            </div>
                        </div>
                        <div className="form-row">
                            <div className="form-group quarter-width">
                                <label>Telefono</label>
                                <input type="text" value={telefono} onChange={(e) => setTelefono(e.target.value)} />
                            </div>
                            <div className="form-group quarter-width">
                                <label>Celular</label>
                                <input type="text" value={celular} onChange={(e) => setCelular(e.target.value)} />
                            </div>
                            <div className="form-group quarter-width">
                                <label>Laboral</label>
                                <input type="text" value={laboral} onChange={(e) => setLaboral(e.target.value)} />
                            </div>
                            <div className="form-group quarter-width">
                                <label>Email</label>
                                <div className="input-with-button">
                                    <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} />
                                </div>
                            </div>
                        </div>
                        <label className="checkbox-inline"><input type="checkbox" checked={habilitarNotificaciones} onChange={(e) => setHabilitarNotificaciones(e.target.checked)} /> Habilitar notificaciones por email</label>
                    </div>

                    {/* Sección Inferior: Observaciones */}
                    <div className="cliente-modal-section bottom-section">
                        <label className="section-title-label">Observaciones al Punto de Venta <span className="icon-info">ⓘ</span></label>
                        <textarea rows="3" placeholder="" onChange={(e) => setObservaciones(e.target.value)}>{observaciones}</textarea>
                    </div>

                    {/* Footer del Modal */}
                    <div className="modal-footer-cliente">
                        <button type="button" className="btn-cancelar-cliente" onClick={handleCancelar}>
                            ❌ Cancelar
                        </button>
                        <button type="submit" className="btn-guardar-cliente">
                            ✅ Guardar
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default ClienteModal;